import { Activity } from '../../../../app/models/activity';
import { Orders } from '../../../../app/models/orders';
import { store } from '../../../../app/stores/store';
import { DeliveryRequest } from '../../../../app/models/deliveryRequest';
import CreateOrderSaveDelivery from './CreateOrderSaveDelivery';
import CreateOrderReceivingSave from './CreateOrderReceivingSave';
import { Dispatch, SetStateAction } from 'react';

function CreateOrderSaveFunction(
  itemLevel: Activity | undefined,
  orderState: Orders,
  deliveryData: DeliveryRequest | undefined,
  sectionModel?: string,
  setIsTableUpdated?: Dispatch<SetStateAction<boolean>>,
  closeForm?: () => void,
  setLoading?: Dispatch<SetStateAction<boolean>>,
) {
  // eslint-disable-next-line
  let currentTaskData = '';
  let currentSubTaskData = '';
  let TemplateDataMain = store.dashboardStore.dashboard.CreateOrderTemplate;
  const taskDetail: any = TemplateDataMain?.tasks;
  if (store.userStore.user?.customerName === 'NFAIReport') {
    let tempCurrentTaskData = [];
    let tempCurrentSubTaskData = [];
    let firstTask = '';
    let firstSubTask = '';
  
    for (let i = 0; i < taskDetail?.length; i++) {
      const dependencyParts = (taskDetail[i].dependencyTask || '').split('|');
      const dependencyTask = dependencyParts[1] !== 'undefined' && dependencyParts[1] !== undefined ? dependencyParts[1]: '';
      if (taskDetail[i].isActive === true) {
        if(i===0){
          taskDetail[i].isParallel = true;
        }
        if (taskDetail[i].isParallel === true && (dependencyTask=== '')) {
          taskDetail[i].isCurrentTask = true;
          tempCurrentTaskData.push(taskDetail[i].taskName); 
          const subtaskDetail = taskDetail[i].subTasks;
          for (let j = 0; j < subtaskDetail?.length; j++) {
            if (subtaskDetail[j].isActive === true  && j===0) {
              subtaskDetail[j].isCurrentSubtask = true;
              tempCurrentSubTaskData.push(subtaskDetail[j].subTaskName);
              break;
            }
          }
        }
      }
    }if (firstTask) {
      tempCurrentTaskData.unshift(firstTask);
  }
  if (firstSubTask) {
      tempCurrentSubTaskData.unshift(firstSubTask);
  }
    currentTaskData = tempCurrentTaskData.join(',');
    currentSubTaskData = tempCurrentSubTaskData.join(',');
  } else {
    for (let i = 0; i < taskDetail?.length; i++) {
      if (taskDetail[i].isActive === true) {
        taskDetail[i].isCurrentTask = true;
        currentTaskData = taskDetail[i].taskName; // setting the task name for update
        const subtaskDetail = taskDetail[i].subTasks;
  
        for (let j = 0; j < subtaskDetail?.length; j++) {
          if (subtaskDetail[j].isActive === true) {
            subtaskDetail[j].isCurrentSubtask = true;
            currentSubTaskData = subtaskDetail[j].subTaskName; // setting the task name for update
            break;
          }
        }
        break;
      }
    }
  }
  const TemplateData = { ...TemplateDataMain, tasks: taskDetail };
  if (
    itemLevel !== undefined &&
    TemplateData !== undefined &&
    store.dashboardStore.dashboard.L2CardValueInventory === 'Receiving'
  ) {
    CreateOrderReceivingSave(
      orderState,
      itemLevel,
      TemplateData,
      currentTaskData,
      currentSubTaskData,
      sectionModel,
      setIsTableUpdated,
      closeForm,
      setLoading,
    ); //for receiving Save function
  }

  if (
    store.dashboardStore.dashboard.L2CardValueInventory === 'Delivery' &&
    deliveryData !== undefined &&
    TemplateData &&
    itemLevel !== undefined
  ) {
    CreateOrderSaveDelivery(
      orderState,
      deliveryData,
      itemLevel,
      TemplateData,
      currentTaskData,
      currentSubTaskData,
      sectionModel,
    ); //for receiving Save function
  }
  store.dashboardStore.showClickedValueForAssetTable('');
  store.dashboardStore.dashboard.AssetTableAssignClicked = '';
  store.dashboardStore.dashboard.createOrderClientId = '';
  store.dashboardStore.dashboard.createOrderDepartmentId = '';
  store.dashboardStore.setCreateOrderClicked(false);
}
export default CreateOrderSaveFunction;
